import { render, staticRenderFns } from "./WheelPage.vue?vue&type=template&id=fc7e5526&scoped=true&"
import script from "./WheelPage.vue?vue&type=script&lang=js&"
export * from "./WheelPage.vue?vue&type=script&lang=js&"
import style0 from "./WheelPage.vue?vue&type=style&index=0&id=fc7e5526&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc7e5526",
  null
  
)

export default component.exports